<template>
  <div>
    <h1>Email clients</h1>
    <v-alert
      :value="true"
      color="info"
    >Choose the team whose clients you wish to email. Select the department that you wish to target, i.e. it will email any clients with primary email address set on those files.</v-alert>
    <v-select
      label="Team"
      v-model="teamid"
      :items="teams"
      item-value="id"
      item-text="name"
      outline
      @change="updatedSelection()"
    >
      <template slot="append-outer" v-if="teamid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a @click="teamid = null" v-on="on">
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Clear filter</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-select
      label="Department"
      v-model="departmentid"
      :items="departments"
      item-value="id"
      item-text="name"
      outline
      @change="updatedSelection()"
    >
      <template slot="append-outer" v-if="departmentid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a @click="departmentid = null" v-on="on">
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Clear filter</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-alert :value="count" color="info">{{`${count} entities`}}</v-alert>
    <template v-if="teamid && departmentid">
      <EmailTemplates
        :tag="'directory_clients'"
        :fileid="$route.params.objectId"
        :entities="$route.params.entities"
        @updated="updated"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" @click="sendEmails()">
            <v-icon>send</v-icon>Send
          </v-btn>
        </template>
        <span>This could take a long time</span>
      </v-tooltip>
    </template>
    <v-dialog v-model="sendingEmails" persistent width="300">
      <v-card color="info" dark>
        <v-card-text>
          <span>Waiting for server to send emails...</span>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EmailTemplates from "@/components/layout/widgets/EmailTemplates";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EmailClients",
  metaInfo() {
    return {
      title: "Email clients",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EmailTemplates },
  data() {
    return {
      teams: [],
      teamid: null,
      departments: [],
      departmentid: null,
      archived: false,
      count: null,
      subject: null,
      body: null,
      sendingEmails: false
    };
  },
  methods: {
    fetchTeams() {
      nbmlaw
        .get(`/cors/admin/directory/teams/list/${this.archived}`)
        .then(response => {
          // console.log(response.data);
          this.teams = response.data;
        })
        .catch(() => {});
    },
    fetchDepartments() {
      nbmlaw.get(`/cors/admin/file/departments`).then(response => {
        // console.log(response.data);
        this.departments = response.data;
      });
    },
    updatedSelection() {
      if (this.teamid && this.departmentid) {
        this.fetchCount();
      } else {
        this.count = null;
      }
    },
    updated(e) {
      if (e) {
        this.subject = e.subject;
        this.body = e.body;
      }
    },
    fetchCount() {
      nbmlaw
        .get(
          `/cors/admin/directory/teams/${this.teamid}/departments/${this.departmentid}/files/count`
        )
        .then(response => {
          // console.log(response.data);
          this.count = response.data;
        });
    },
    sendEmails() {
      this.sendingEmails = true;
      nbmlaw
        .put(
          `/cors/admin/directory/teams/${this.teamid}/departments/${this.departmentid}/files/email`,
          null,
          {
            params: { subject: this.subject, body: this.body }
          }
        )
        .then(() => {
          // console.log(response.data);
          this.sendingEmails = false;
        });
    }
  },
  created() {
    this.fetchTeams();
    this.fetchDepartments();
  }
};
</script>
